import {confirmSignUp,fetchAuthSession,getCurrentUser,resetPassword,signIn,signOut,
signInWithRedirect,
} from "@aws-amplify/auth";

/* ================================
   GUEST
================================ */

export async function signInAsGuest() {
  await signIn({
    username: process.env.REACT_APP_MOVE_GUEST!,
    password: process.env.REACT_APP_MOVE_GUEST_PASSWORD!,
  });
}

/* ================================
   LOGIN COGNITO
================================ */

export async function cognitoSignIn(email: string, password: string) {
  return signIn({
    username: email,
    password,
  });
}
/* ================================
   LOGIN GOOGLE
================================ */

export async function cognitoGoogleSignIn() {
  // Faz logout do usuário atual (Guest)
  await signOut();
  return signInWithRedirect({
    provider: "Google",
  });
}
/* ================================
   CONFIRM REGISTER
================================ */

export async function cognitoConfirmSignUp(email: string, code: string) {
  return confirmSignUp({
    username: email,
    confirmationCode: code,
  });
}

/* ================================
   RESET PASSWORD
================================ */

export async function cognitoResetPassword(email: string) {
  return resetPassword({
    username: email,
  });
}

/* ================================
   LOGOUT
================================ */

export async function cognitoSignOut() {
  await signOut();
  await signInAsGuest();
}

/* ================================
   SESSION
================================ */

export async function cognitoGetSession() {
  return fetchAuthSession();
}

/* ================================
   CURRENT USER
================================ */

export async function cognitoGetCurrentUser() {
  const user = await getCurrentUser();
  return {
    userId: user.userId,
    username: user.username,
    signInDetails: user.signInDetails,
  };
}
